import { seobotDetail } from "./seoBotAccountReducer";

export const seo_bot_details = (query) => async (dispatch) => {
    try {
        dispatch(seobotDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};

